import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2d6da19a&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6da19a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6da19a')) {
      api.createRecord('2d6da19a', component.options)
    } else {
      api.reload('2d6da19a', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=2d6da19a&scoped=true", function () {
      api.rerender('2d6da19a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adver/edit.vue"
export default component.exports